import { isMackerelRegional, withMackerelScope } from "../../features/fishingIntelligence/mackerelCapabilities";
import React, { useId, useMemo } from "react";
import { CircleHelp, ShieldAlert } from "lucide-react";
import { buildPointExplanationModel } from "../../features/fishingIntelligence/fishingIntelligenceExplanations";
import "../../styles/components/FishingIntelligenceExplanations.css";

export default function FishingIntelligenceExplanations({
  context,
  point,
  t,
  variant = "current",
}) {
  t = withMackerelScope(t, context);
  const regional = isMackerelRegional(context);
  const titleId = useId();
  const model = useMemo(
    () => buildPointExplanationModel({ context, point }),
    [context, point]
  );
  const isCurrent = variant === "current";
  if (!isCurrent && !model.items.length) return null;

  return (
    <section
      className={`rp-intel-explanations rp-intel-explanations--${variant}`}
      aria-labelledby={titleId}
    >
      <div className="rp-intel-explanations__heading">
        <CircleHelp size={18} aria-hidden="true" />
        <div>
          <h4 id={titleId}>
            {t(
              isCurrent
                ? "fishing_today_intelligence_explanation_title"
                : "fishing_today_intelligence_selected_explanation_title"
            )}
          </h4>
          {isCurrent ? (
            <p>{t(model.isSeaBassMultifactor ? "sea_bass_opportunity_semantics" : "fishing_today_intelligence_explanation_opportunity")}</p>
          ) : null}
        </div>
      </div>

      {model.items.length ? (
        <ul className="rp-intel-explanations__items">
          {model.items.map((item) => (
            <li key={item.id}>{t(item.key)}</li>
          ))}
        </ul>
      ) : (
        <p className="rp-intel-explanations__limited">
          {t("fishing_today_intelligence_explanation_limited")}
        </p>
      )}

      {isCurrent ? (
        <>
          <details className="rp-intel-explanations__scope">
            <summary>{t("fishing_today_intelligence_scope_title")}</summary>
            <div>
              <strong>{t("fishing_today_intelligence_scope_included")}</strong>
              <ul>
                {model.hasSeasonFactor ? (
                  <li>{t("fishing_today_intelligence_scope_season")}</li>
                ) : null}
                {model.hasTemperatureFactor ? (
                  <li>
                    {t(
                      model.isCommonCarp
                        ? "fishing_today_intelligence_scope_measured_freshwater_temperature"
                        : "fishing_today_intelligence_scope_temperature"
                    )}
                  </li>
                ) : null}
                <li>{t("fishing_today_intelligence_scope_location")}</li>
                <li>{t("fishing_today_intelligence_scope_confidence")}</li>
                {model.hasDielFactor ? <li>{t("sea_bass_diel")}</li> : null}
              </ul>
              <strong>{t("fishing_today_intelligence_scope_not_used")}</strong>
              <ul>
                {regional ? <li>{t("mackerel_unmodelled_scope")}</li> : null}
                <li>{t("fishing_today_intelligence_scope_habitat")}</li>
                <li>{t("fishing_today_intelligence_scope_tide")}</li>
                {!model.isSeaBassMultifactor ? <li>{t("fishing_today_intelligence_scope_light")}</li> : null}
              </ul>
            </div>
          </details>
          <p className="rp-intel-explanations__safety">
            <ShieldAlert size={16} aria-hidden="true" />
            <span>{t("fishing_today_intelligence_safety_disclosure")}</span>
          </p>
        </>
      ) : null}
    </section>
  );
}
